<div class="main-container">
  <form [formGroup]="ModelFirmwareForm" novalidate>
    <!-- Component Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
      </div>

      <span class="page-title">{{
        (isAddForm ? 'Create' : 'View/Update') + ' Device Model'
      }}</span>
    </div>

    <!-- Component Body Section -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Fill Device Model Details</h6>
        <div class="component-actions"></div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <div class="component-body">
        <div class="form-section">
          <div class="form-group">
            <label for="portOne" class="form-label">Model Code</label>
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Model Code</mat-label>
              <input
                placeholder="Model Code"
                formControlName="modelCode"
                matInput
                type="text"
                required
              />
              @if (
                ModelFirmwareForm.controls['modelCode'].touched &&
                ModelFirmwareForm.controls['modelCode'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelCode'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }

              @if (
                ModelFirmwareForm.controls['modelCode'].touched &&
                ModelFirmwareForm.controls['modelCode'].errors
                  ?.singleSpaceOrHyphen
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelCode'].errors
                      ?.singleSpaceOrHyphen
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="portOne" class="form-label">Model Name</label>
            <mat-form-field class="form-label" appearance="outline">
              <mat-label>Model Name</mat-label>
              <input
                placeholder="Model Name"
                formControlName="modelName"
                matInput
                type="text"
                required
              />
              @if (
                ModelFirmwareForm.controls['modelName'].touched &&
                ModelFirmwareForm.controls['modelName'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelName'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }

              @if (
                ModelFirmwareForm.controls['modelName'].touched &&
                ModelFirmwareForm.controls['modelName'].errors
                  ?.singleSpaceOrHyphen
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelName'].errors
                      ?.singleSpaceOrHyphen
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="portOne" class="form-label"
              >Model Serial Sequence</label
            >
            <mat-form-field class="form-label" appearance="outline">
              <mat-label>Model Serial Sequence</mat-label>
              <input
                placeholder="Model Serial Sequence"
                formControlName="modelSerialSequence"
                matInput
                type="text"
                required
              />
              @if (
                ModelFirmwareForm.controls['modelSerialSequence'].touched &&
                ModelFirmwareForm.controls['modelSerialSequence'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelSerialSequence'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }

              @if (
                ModelFirmwareForm.controls['modelSerialSequence'].touched &&
                ModelFirmwareForm.controls['modelSerialSequence'].errors
                  ?.alphaNumericOnly
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['modelSerialSequence'].errors
                      ?.alphaNumericOnly
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-group">
            <label for="portOne" class="form-label">Hardware Version</label>
            <mat-form-field class="form-label" appearance="outline">
              <mat-label>Hardware Version</mat-label>
              <input
                placeholder="Hardware Version"
                formControlName="hardwareVersion"
                matInput
                type="text"
                required
              />
              @if (
                ModelFirmwareForm.controls['hardwareVersion'].touched &&
                ModelFirmwareForm.controls['hardwareVersion'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['hardwareVersion'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }

              @if (
                ModelFirmwareForm.controls['hardwareVersion'].touched &&
                ModelFirmwareForm.controls['hardwareVersion'].errors
                  ?.alphaNumericOnly
              ) {
                <mat-error>
                  {{
                    ModelFirmwareForm.controls['hardwareVersion'].errors
                      ?.alphaNumericOnly
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <div class="component-footer">
        <div class="button-group">
          @if (isAddForm) {
            <button
              class="submit-button"
              (click)="validateFormSave()"
              [disabled]="this.ModelFirmwareForm.invalid"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }

          @if (!isAddForm) {
            <button class="edit-button" (click)="validateFormUpdate()">
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </form>
</div>
